<template>
  <div class="py-4 container-fluid">
    <div class=" row">
      <div class="col-12">
        <div class="card">

          <div class="card-header pb-0">
            <div class="d-flex align-items-center justify-content-between">
              <span class="section-title">LISTA DE COMPRAS</span>
              <router-link :to="{ name: 'Purchases Create' }" class="btn btn-sm bg-gradient-warning mb-0"
                data-toggle="tooltip" data-original-title="Agregar compra">
                Agregar compra <i class="fa fa-plus ms-1"></i>
              </router-link>
            </div>

            <!-- se agg una row mas para la busqueda-->
            <div class="row">

              <!-- Columna de búsqueda -->
              <div class="col-md-6 mb-3">
                <label for="searchQuery" class="mb-1">Buscar</label>
                <input type="text" v-model="searchQuery" id="searchQuery" class="form-control"
                  placeholder="Buscar proveedor..." @input="fetchData(null)" />
              </div>

              <!-- Columna de fechas -->
              <div class="col-md-3 mb-3">
                <label for="startDate" class="mb-1">Desde</label>
                <input type="date" v-model="startDate" id="startDate" class="form-control" @change="fetchData(null)" />
              </div>
              <div class="col-md-3 mb-3">
                <label for="endDate" class="mb-1">Hasta</label>
                <input type="date" v-model="endDate" id="endDate" class="form-control" @change="fetchData(null)" />
              </div>

            </div>

          </div>
          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">

              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Proveedor</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Total
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Fecha
                    </th>
                    <th class="text-secondary text-center text-uppercase text-xxs font-weight-bolder opacity-7">
                      Acciones
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="value in data" :key="value.id">
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ value.supplier }}</h6>
                        </div>
                      </div>
                    </td>
                    <td class="align-middle text-center text-sm">
                      {{ parseFloat(value.total).toLocaleString('es-ES', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      }) }}
                    </td>

                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold">
                        {{ new Date(value.updated_at).toLocaleDateString('es-ES') }}
                      </span>
                    </td>
                    <td class="align-middle text-center">
                      <router-link
                        :to="{ name: 'Purchases Create', params: { data: JSON.stringify(value) }, props: true }"
                        class="text-secondary font-weight-bold text-xs" data-toggle="tooltip"
                        data-original-title="Editar Registro">
                        <i :class="value.status === 0 ? 'fa fa-pencil-alt' : 'fa fa-eye'"></i>
                      </router-link>


                      <a @click="deleteUser(value.id)" class="text-secondary font-weight-bold text-xs cursor-pointer"
                        style="margin-left: 15px;" data-toggle="tooltip" data-original-title="Eliminar registro"
                        v-if="value.status == 0">
                        <i class="fa fa-trash"></i>
                      </a>

                    </td>
                  </tr>

                  <tr v-if="data.length === 0">
                    <td colspan="4" class="text-center text-xxs">No hay registros disponibles</td>
                  </tr>
                </tbody>
              </table>


              <!-- Paginación -->
              <div class="pagination p-3">
                <a v-for="link in links" :key="link.label" class="page-item cursor-pointer"
                  @click="fetchData(link.url)" :disabled="!link.url || link.active"
                  :class="{ 'active': link.label === currentPage.toString() }">
                  {{ link.label }}
                </a>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { mapGetters } from 'vuex';
import Swal from 'sweetalert2';
export default {
  name: 'ProjectsList',

  data() {
    return {
      searchQuery: '',
      startDate: '',
      endDate: ''
    };
  },



  computed: {
    ...mapGetters('purchases', ['allData', 'currentPage', 'lastPage', 'pagination', 'links']), // Mapea el getter allUsers
    currentPage() {
      return this.$store.state.purchases.currentPage; // Obtiene la página actual
    },
    lastPage() {
      return this.$store.state.purchases.lastPage; // Obtiene la última página
    },
    data() {
      return this.allData; // Retorna los usuarios desde el store
    },
    links() {
      return this.$store.getters['purchases/links']; // Retorna los links
    },
  },

  methods: {
    async fetchData(pageUrl = null) {
      const params = {
        search: this.searchQuery,
        start_date: this.startDate,
        end_date: this.endDate,
        page: pageUrl ? new window.URL(pageUrl).searchParams.get("page") || 1 : 1
      };
      await this.$store.dispatch('purchases/fetchData', params);
    },
    async deleteUser(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("purchases/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {

            this.fetchData();

            await Swal.fire(
              'Eliminado!',
              'El registro se ha sido eliminado correctamente.',
              'success'
            );
          } else {
            throw new Error(response.data.message || 'Error al eliminar el empleado');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    }

  },
  mounted() {
    this.fetchData(); // Llama a fetchUsers cuando el componente se monta
  },
};
</script>

<style scoped>
.section-title {
  font-weight: 800;
  color: #1f2d5a;
  letter-spacing: 0.6px;
}

.section-title::after {
  content: "";
  display: block;
  width: 44px;
  height: 3px;
  margin-top: 6px;
  border-radius: 999px;
  background: #f6a500;
}

.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.page-item {
  margin: 0 5px;
}

.active {
  font-weight: bold;
  /* Estilo para la página activa */
}
</style>